import React from "react";
import { Navigate, Route } from "react-router-dom";
import { ParentGuard } from "../../ParentGuard";
import MyDirectoryProfile from "../../pages/MyDirectoryProfile";
import ParentAlumniPreferences from "./ParentAlumniPreferences";
import ParentPortal from "./index";
import ParentPortalLayout from "./ParentPortalLayout";
import ParentProfile from "./ParentProfile";
import PpFamilySelector from "./pp-FamilySelector";

export const createParentPortalRoutes = () => (
  <Route element={<ParentGuard />}>
    <Route element={<ParentPortalLayout />}>
      <Route path="/portal" element={<ParentPortal />} />
      <Route path="/portal/select-family" element={<PpFamilySelector />} />
      <Route path="/portal/my/directory-profile" element={<MyDirectoryProfile />} />
      <Route path="/portal/directory" element={<Navigate to="/portal?tab=directory" replace />} />
      <Route path="/portal/profile" element={<ParentProfile />} />
      <Route path="/portal/alumni-preferences" element={<ParentAlumniPreferences />} />
      <Route path="/portal/school-tasks" element={<Navigate to="/portal?tab=actions&view=school-tasks" replace />} />
    </Route>
  </Route>
);
